import cookie from 'react-cookie';
import { browserHistory } from 'react-router';

export const GET_STUDENTS = 'GET_STUDENTS';
export const GET_CLASSLIST = 'GET_CLASSLIST';
export const GET_CLASS_INFO = 'GET_CLASS_INFO';
export const SIGNUP_LESSON = 'SIGNUP_LESSON';
export const SIGNUP_CLASS = 'SIGNUP_CLASS';
export const CHANGE_CLASS_SIGNUP_STATUS = 'CHANGE_CLASS_SIGNUP_STATUS';
const APPLY_DONE = 'APPLY_DONE';

/**
 * 取得區間內用戶所有學生的課程及報名狀態
 * 
 * @export
 * @param {any} id 
 * @returns 
 * @filter=
{
  "include":{
    "relation": "sign_ups",
    "scope":{
      "include":["class","class_lesson","point_use_log"],
      "where": {
        "date": {
          "between":["2016-12-01T00:00:00+0800","2016-12-31T23:59:59+0800"] //拿取日期區間內的報名資料
        }
      }
    }
  }
}
 */
export function getStudents(params = {}){

    const user_id = cookie.load('user_id');
    const nowString = params.now.format("YYYY-MM");
    const dataBetween = [`${nowString}-01T00:00:00+0800`, `${nowString}-31T23:59:59+0800`]

    params.filter = {
        "include":{
            "relation": "sign_ups",
            "scope":{
                "include":["class","class_lesson"],
                "where": {
                    "date": {
                        "between": dataBetween //拿取日期區間內的報名資料
                    }
                }
            }
        }
    }

    params.now = null;

	return {
		CALL_API: {
			type: GET_STUDENTS,
			method: 'get',
			target: `/users/${user_id}/students`,
            header: {
                Authorization: cookie.load('token')
            },
            params
		}
	}
}

/**
 * 課程列表
 */

export function getClassList(){
    let params = {
        filter: {
            "where": {"disable": "false"}
        }
    }
	return {
		CALL_API: {
			type: GET_CLASSLIST,
			method: 'get',
            target: '/classes',
            params
        }
    }
}

/**
 * 單一課程時段列表及所開出的課堂資訊
 * @param {*} params : { class_id }
 */

export function getClassInfo(params){

	params.filter = {
        "where": {"disable": false},
		"include": {"class_lessons": "sign_ups"}
	}

	return {
		CALL_API: {
			type: GET_CLASS_INFO,
			method: 'get',
			target: `/classes/${params.class_id}/class_times`,
            params
		}
	}
}

/**
 * 報名單一課堂 (前端)
 * @param {*} params : { user_id, student_id, lesson_id }
 */
export const singupLesson = (params) => (dispatch, getState) => {
    //console.log(params);
    return dispatch({
        CALL_API: {
            type: SIGNUP_LESSON,
            method: 'post',
            target: `/users/${params.user_id}/singleSignUp/${params.lesson_id}`,
            header: {
                Authorization: cookie.load('token')
            },
			params: {
                student_id: params.student_id
            }
        }
    })
}

/**
 * 報名為課程固定生 (前端)
 * @param {*} params : { user_id, student_id, class_time_id }
 */
export const singupClass = (params) => (dispatch, getState) => {
    return dispatch({
        CALL_API: {
            type: SIGNUP_CLASS,
            method: 'post',
            target: `/users/${params.user_id}/signUpForFixedMember/${params.class_time_id}`,
            header: {
                Authorization: cookie.load('token')
            },
			params: {
                student_id: params.student_id
            }
        }
    })
}

/**
 * 
 * @param {*} params = { user_id, signup_id, action}
 * @action = non-arrival, absence, arrival
 */
export function changeClassSingupStatus (params) {
    
    const user_id = cookie.load('user_id');
    //console.log(params);
    return {
        CALL_API: {
            type: CHANGE_CLASS_SIGNUP_STATUS,
            method: 'post',
            target: `/users/${user_id}/changeSingUpStatus/${params.signup_id}`,
            header: {
                Authorization: cookie.load('token')
            },
			params
        }
    }
}

export function cancelFixedSignUp (params) {
    
    const user_id = cookie.load('user_id');
    //console.log(params);
    return {
        CALL_API: {
            type: CHANGE_CLASS_SIGNUP_STATUS,
            method: 'post',
            target: `/users/${user_id}/cancelFixedSignUp/${params.signup_id}`,
            header: {
                Authorization: cookie.load('token')
            }
        }
    }
}


// function applyDone(params) {
//     //console.log(params);
//     if( response.fixed ) {
//         browserHistory.push({
//             pathName: `/classFixed/${class_id}/${class_time_id}/done`,
//             state: { params }
//         })
//     }else {
//         browserHistory.push({
//             pathName: `/class/${class_id}/${class_lesson_id}/done`,
//             state: { params }
//         })
//     }

//     return {
//         type: APPLY_DONE,
//         params
//     }
// }


/** WEBPACK FOOTER **
 ** ./src/actions/class.js
 **/